import { User } from '../models'
import { Module, ActionContext } from 'vuex'
import { RootState, UsersState } from './state_models'
import sortBy from 'lodash-es/sortBy'
import { UsersService } from '../services'
import { transformUserApiData } from '../util/helper'
import { getAllUsersByLocationId } from '../services/UsersServiceHelpers'

let userListner

export const users: Module<UsersState, RootState> = {
  namespaced: true,
  state: { users: [], locationId: '' },
  getters: {
    getById: (state: UsersState) => {
      return (userId: string) => state.users.find(x => x.id === userId)
    },
    getAll: (state: UsersState) => {
      return [...state.users.map(a => new User(a))]
    },
  },
  mutations: {
    set: (state: UsersState, payload: { users: any[]; locationId: string }) => {
      state.users = payload.users
      state.locationId = payload.locationId
    },
    clearAll: (state: UsersState) => {
      if (userListner) {
        userListner()
      }

      state.users = []
      state.locationId = undefined
    },
  },
  actions: {
    async syncAll(
      context: ActionContext<UsersState, RootState>,
      options: string | { locationId: string; force: boolean }
    ) {
      let force = false
      let locationId = options
      if (typeof options === 'object') {
        locationId = options.locationId
        force = options.force
      }

      if (!locationId) {
        context.commit('clearAll')
        return
      }

      if (context.state.locationId === locationId && !force) {
        return context.state.users
      }

      return new Promise(async resolve => {
        try {
          // Get companyId from root state if available for better query performance
          const companyId = context.rootState.company?.company?.id

          // Use new paginated search endpoint with parallel fetching
          const resp = await getAllUsersByLocationId(locationId, companyId, 500, 3)

          const users = resp.users.map(u => {
            return transformUserApiData(u)
          })

          context.commit('set', {
            locationId: locationId,
            users: sortBy(users, [user => (user.first_name ? user.first_name.toLowerCase() : '')]),
          })

          resolve(context.state.users)
        } catch (err) {
          console.log(err)
          resolve([])
        }
      })
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<UsersState, RootState>) => {
        context.commit('clearAll')
      },
    },
  },
}
